import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarFallback, AvatarImage } from '@achra/ui/avatar';
import type { ResourceOperatorFieldsFragment } from '@/modules/__generated__/graphql/switchboard-generated';
interface OperatorBadgeProps {
  operator: ResourceOperatorFieldsFragment;
}
function OperatorBadge(t0) {
  const $ = _c(21);
  const {
    operator
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-muted-foreground text-sm/5">Offered by:</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = operator.name ?? "";
  let t3;
  if ($[1] !== operator.icon || $[2] !== t2) {
    t3 = <AvatarImage src={operator.icon} alt={t2} />;
    $[1] = operator.icon;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== operator.name) {
    t4 = operator.name?.charAt(0).toUpperCase() ?? "U";
    $[4] = operator.name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <AvatarFallback className="text-xs">{t4}</AvatarFallback>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <Avatar className="size-6">{t3}{t5}</Avatar>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== operator.code) {
    t7 = <span className="text-foreground/30">{operator.code}</span>;
    $[11] = operator.code;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== operator.name) {
    t8 = <span className="text-foreground">{operator.name}</span>;
    $[13] = operator.name;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="flex gap-1 text-sm/5 font-semibold">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <div className="flex flex-wrap items-center gap-x-2 gap-y-0">{t1}{t6}{t9}</div>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
export { OperatorBadge };